const FORMAT_HHMM = 'HH:mm';
const FORMAT_HHMMSS = 'HH:mm:ss';
const FORMAT_YMD = 'YYYY-MM-DD';
const FORMAT_YMD_HHMMSS = 'YYYY-MM-DD HH:mm:ss';
const FORMAT_YMD_TIMEZONE = 'YYYY-MM-DD HH:mm zz';
const FORMAT_YMD_HHMMSS_TIMEZONE = 'YYYY-MM-DD HH:mm:ss zz';
const OLD_FORMAT_YMD_TIMEZONE = 'DD.MM.YYYY HH:mm:ss z';
const FORMAT__HHMMSS_xxx = 'HH:mm:ss.SSS';
const START_OF_DAY = '00:00';
const END_OF_DAY = '23:59';
const FORMAT_MS = 'x';
const SECOND_TO_DAY_END = 3600 * 24;
const TIME_FORMATS = {
  HOUR_MINUTE: '%H:%M',
  NAMED_DAY: '%a',
  DAY_MONTH: '%d.%b',
  DAY_MONTH_HOUR_MINUTE: '%d.%b %H:%M'
};

export {
  FORMAT_HHMM,
  FORMAT_HHMMSS,
  FORMAT_YMD,
  FORMAT_YMD_HHMMSS,
  FORMAT_YMD_HHMMSS_TIMEZONE,
  FORMAT__HHMMSS_xxx,
  START_OF_DAY,
  END_OF_DAY,
  FORMAT_MS,
  SECOND_TO_DAY_END,
  TIME_FORMATS,
  FORMAT_YMD_TIMEZONE,
  OLD_FORMAT_YMD_TIMEZONE
};
